import request from '@/utils/request';

export const querycountrynotice = (params) => {
  return request('/org_api/v1/org/querycountrynotice', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const addcountrynotice = (params) => {
  return request('/org_api/v1/org/addcountrynotice', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const countrynoticedetail = (params) => {
  return request('/org_api/v1/org/countrynoticedetail', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const updatecountrynotice = (params) => {
  return request('/org_api/v1/org/updatecountrynotice', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const delcountrynotice = (params) => {
  return request('/org_api/v1/org/delcountrynotice', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}



export const queryvisacountryguide = (params) => {
  return request('/org_api/v1/org/queryvisacountryguide', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const addvisacountryguide = (params) => {
  return request('/org_api/v1/org/addvisacountryguide', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const visacountryguidedetail = (params) => {
  return request('/org_api/v1/org/visacountryguidedetail', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const updatevisacountryguide = (params) => {
  return request('/org_api/v1/org/updatevisacountryguide', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const delvisacountryguide = (params) => {
  return request('/org_api/v1/org/delvisacountryguide', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const querycountrysort = (params) => {
  return request('/org_api/v1/org/querycountrysort', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const updatecountrysort = (params) => {
  return request('/org_api/v1/org/updatecountrysort', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const queryvisasmalltype = (params) => {
  return request('/org_api/v1/org/queryvisasmalltype', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const addvisasmalltype = (params) => {
  return request('/org_api/v1/org/addvisasmalltype', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const visasmalltypedetail = (params) => {
  return request('/org_api/v1/org/visasmalltypedetail', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}
export const updatevisasmalltype = (params) => {
  return request('/org_api/v1/org/updatevisasmalltype', {
    method: 'post',
    data: { ...params },//post请求使用data

  })
}
export const delvisasmalltype = (params) => {
  return request('/org_api/v1/org/delvisasmalltype', {
    method: 'get',
    params: { ...params },//get请求使用params

  })
}